import { FormattedActivityLog } from "@idw-types/data/reports";
import { OrganizationActivitySearchFiltersState } from "@idw-types/state/organization-activity-state";

export enum OrganizationActivityActionTypes {
    // Search
    SET_ORGANIZATION_ACTIVITY_SEARCH_FILTERS = "SET_ORGANIZATION_ACTIVITY_SEARCH_FILTERS",
    SET_ORGANIZATION_ACTIVITY_SEARCH_RESULTS_LOADING = "SET_ORGANIZATION_ACTIVITY_SEARCH_RESULTS_LOADING",
    SET_ORGANIZATION_ACTIVITY_SEARCH_RESULTS = "SET_ORGANIZATION_ACTIVITY_SEARCH_RESULTS",
}

// Search
type SetOrganizationActivitySearchFiltersAction = {
    type: OrganizationActivityActionTypes.SET_ORGANIZATION_ACTIVITY_SEARCH_FILTERS;
    payload: { searchFilters: OrganizationActivitySearchFiltersState };
};

export const setOrganizationActivitySearchFilters = (searchFilters: OrganizationActivitySearchFiltersState): SetOrganizationActivitySearchFiltersAction => ({
    type: OrganizationActivityActionTypes.SET_ORGANIZATION_ACTIVITY_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetOrganizationActivitySearchResultsLoadingAction = {
    type: OrganizationActivityActionTypes.SET_ORGANIZATION_ACTIVITY_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setOrganizationActivitySearchResultsLoading = (isLoading: boolean): SetOrganizationActivitySearchResultsLoadingAction => ({
    type: OrganizationActivityActionTypes.SET_ORGANIZATION_ACTIVITY_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetOrganizationActivitySearchResultsAction = {
    type: OrganizationActivityActionTypes.SET_ORGANIZATION_ACTIVITY_SEARCH_RESULTS;
    payload: { activityLogs: Array<FormattedActivityLog> };
};

export const setOrganizationActivitySearchResults = (activityLogs: Array<FormattedActivityLog>): SetOrganizationActivitySearchResultsAction => ({
    type: OrganizationActivityActionTypes.SET_ORGANIZATION_ACTIVITY_SEARCH_RESULTS,
    payload: { activityLogs }
});

export type OrganizationActivityActions =
    // Search
    SetOrganizationActivitySearchFiltersAction |
    SetOrganizationActivitySearchResultsLoadingAction |
    SetOrganizationActivitySearchResultsAction